import { Injectable } from '@angular/core';
import { InputCreationFeedback } from '@app/inputs/inputs-api.model';
import { NgxHttpClient } from '@app/shared/ngx-http-client';
import { ApiServiceBase } from '@dg/shared-services';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { APIParameterModel, APIResponseModel } from '../event.model';

@Injectable({ providedIn: 'root' })
export class EventService extends ApiServiceBase {
  private i18n = this.translateService.instant([
    'InputsSvc_GeneralError',
    'InputsSvc_AddItemError',
    'InputsSvc_GetEventError',
  ]);

  constructor(
    private translateService: TranslateService,
    public override http: NgxHttpClient
  ) {
    super(http, translateService.instant('InputsSvc_GeneralError'));
  }

  /**
   * Add event to Catalog/Pathway/Plan
   */
  public addEvent(
    params: APIParameterModel
  ): Observable<InputCreationFeedback> {
    return this.post(
      '/inputs/addevent',
      params,
      this.i18n.InputsSvc_AddItemError
    );
  }

  public updateEvent(params: APIParameterModel): Observable<void> {
    return this.put('/inputs/updateevent', params);
  }

  public getEvent(
    inputId: number,
    isCms = false
  ): Observable<APIResponseModel> {
    return this.get(
      '/inputs/getevent',
      {
        inputId,
        isCms,
        useResourceImages: true,
      },
      this.i18n.InputsSvc_GetEventError
    );
  }
}
